import * as React from 'react';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { TransitionProps } from '@mui/material/transitions';
import AdvancedSearch from '../../pages/AdvancedSearch/AdvancedSearch';
import { Prompt, useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { useLayoutEffect } from 'react';
import { BsWindowSidebar } from 'react-icons/bs';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});





const AdvancedSearchModal = NiceModal.create(() => {
    const modal = useModal();
    const openModalHashStateId = "advancedSearch";


    useLayoutEffect(() => {
        if (modal.visible) {
            localStorage.setItem("modalOpen", JSON.stringify({ name: "advancedSearch" }))
            window.history.pushState({ openModalHashStateId }, `modal: ${openModalHashStateId}`, `./modal=${openModalHashStateId}`)
        }
    }, [modal.visible])


    const handleCloseModalButton = () => {
        window.history.back();
        modal.hide();
    }





    return (
        <>
            <div>

                <Dialog
                    sx={{ "& .MuiDialog-paper": { backgroundColor: "#f5f4f9" } }}
                    fullScreen
                    TransitionComponent={Transition}
                    open={modal.visible}
                    disableEscapeKeyDown={true}
                    onClose={handleCloseModalButton}
                >
                    <div className='advanced-container' style={{ overflowY: "auto" }}>
                        <AdvancedSearch />
                    </div>

                </Dialog>
            </div>
        </>


    )
})


export default AdvancedSearchModal;